module.exports = __webpack_public_path__ + "img/solarpannel.9b92e3b6.svg";